import React from 'react';
import { useTranslation } from 'react-i18next';
import PageSection from 'components/PageSection';
import managedMarketplace from 'assets/images/managed-marketplace.png';
import { Body1, SectionTitle } from 'components/Typography';

const AccessOffSiteEnergy = () => {
    const { t } = useTranslation('product');
    return (
        <PageSection className="py-32">
            <div className="flex flex-col lg:flex-row gap-8 lg:items-end">
                <div className="flex-1">
                    <SectionTitle className="fade-in-scroll mb-8">{t('access.title')}</SectionTitle>
                    <Body1 className="fade-in-scroll mb-4">{t('access.body1')}</Body1>
                    <Body1 className="fade-in-scroll">{t('access.body2')}</Body1>
                </div>

                <div className="fade-in-scroll flex-1">
                    <img className="w-full" src={managedMarketplace} alt="" />
                </div>
            </div>
            <div className="w-full overflow-x-scroll md:overflow-hidden mt-16 pb-4 md:pb-0">
                <div className="flex justify-center gap-8 pt-16 md:px-12 w-[160vw] md:w-full">
                    <div className="fade-in-scroll flex-1 bg-primary text-white p-8 rounded-xl">
                        <Body1>{t('access.card1')}</Body1>
                    </div>
                    <div className="fade-in-scroll flex-1 bg-primary text-white p-8 rounded-xl">
                        <Body1>{t('access.card2')}</Body1>
                    </div>
                </div>
            </div>
        </PageSection>
    );
};

export default AccessOffSiteEnergy;
